import {
  getReq,
  // postReq,
  // deleteSendReq,
  // putReq,
  // getCPHeaderMap,
  getHeaderCodeMap,
  // exportExcelReq,
  END_POINTS
} from '@/api'
// import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  // emptySearchInfo: {
  //   searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
  //   searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
  //   searchMonthType: 'CURRENT', // CURRENT, TOTAL
  //   searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
  //   searchDocMth: '',
  //   searchDocIndex: 0,
  //   searchDocMonthIndex: '',
  //   searchDocType: '',
  //   searchFirstId: '',
  //   searchLastId: '',
  //   searchAction: 'SEARCH' // SEARCH, REFRESH, PREV, NEXT
  // },
  // searchInfo: {
  //   // entityId: '',
  //   // projId: '',
  //   // compId: '',
  //   searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
  //   searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
  //   searchMonthType: 'CURRENT', // CURRENT, TOTAL
  //   searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
  //   searchDocMth: '',
  //   searchDocIndex: 0,
  //   searchDocMonthIndex: '',
  //   searchDocType: '',
  //   searchFirstId: '',
  //   searchLastId: '',
  //   searchAction: 'SEARCH' // SEARCH, REFRESH, PREV, NEXT
  // },
  // searchedForm: {
  //   // entityId: '',
  //   // projId: '',
  //   // compId: '',
  //   searchType: 'MONTH',
  //   searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
  //   searchMonthType: 'CURRENT', // CURRENT, TOTAL
  //   searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
  //   searchDocMth: '',
  //   searchDocIndex: 0,
  //   searchDocMonthIndex: '',
  //   searchDocType: '',
  //   searchFirstId: '',
  //   searchLastId: '',
  //   searchAction: 'SEARCH' // SEARCH, REFRESH, PREV, NEXT
  // },
  recordHistDataAuditList: [],
  // actionListObject: {
  //   actionList: [],
  //   firstId: '',
  //   lastId: '',
  //   searchAction: '',
  //   indPrev: '',
  //   indNext: ''
  // },
  END_STATE: null
}

const getters = {

}

const actions = {
  async findRecordHistDataAuditList({
    commit,
    state,
    rootState
  }, { dataAuditId, projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RECORD_HIST_DATA_AUDIT_LIST + `?dataAuditId=${dataAuditId}&projId=${projId}&compId=${compId}`, {
      // headerMap: await getCPHeaderMap(compId, projId)
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // let searchedForm = state.searchedForm || state.emptySearchInfo
    // let data = {
    //   // transId: transId,
    //   // entityId: entityId,
    //   // projId: projId,
    //   // compId: compId,
    //   searchType: searchedForm.searchType,
    //   searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
    //   searchMonthType: searchedForm.searchMonthType,
    //   startDt: new Date(searchedForm.searchDtScope[0]).getTime(),
    //   endDt: new Date(searchedForm.searchDtScope[1]).getTime(),
    //   searchDocMth: searchedForm.searchDocMth,
    //   searchDocIndex: searchedForm.searchDocIndex || 0,
    //   searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
    //   searchDocType: searchedForm.searchDocType || '',
    //   searchFirstId: searchedForm.searchFirstId || '',
    //   searchLastId: searchedForm.searchLastId || '',
    //   searchAction: searchedForm.searchAction || 'SEARCH'
    // }
    //
    // const response = await getReq(END_POINTS.FIND_DATA_AUDIT_LIST_BY_LOG_UID, {
    //   data,
    //   // headerMap: await getCPHeaderMap(compId, projId),
    //   headerCodeMap: await getHeaderCodeMap(codeParam)
    // })
    // return response
    // commit('updateSearchedForm', data)
    // commit('updateProjIncomeTransList', response)
  },
  // async downloadProjIncomeTransList({
  //   commit,
  //   state,
  //   rootState
  // }, { entityId, projId, compId, codeParam }) {
  //   let searchedForm = state.searchedForm || state.emptySearchInfo
  //   let data = {
  //     entityId: entityId,
  //     projId: projId,
  //     compId: compId,
  //     searchType: searchedForm.searchType,
  //     searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
  //     searchMonthType: searchedForm.searchMonthType,
  //     startDt: new Date(searchedForm.searchDtScope[0]).getTime(),
  //     endDt: new Date(searchedForm.searchDtScope[1]).getTime(),
  //     searchDocMth: searchedForm.searchDocMth,
  //     searchDocIndex: searchedForm.searchDocIndex || 0,
  //     searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
  //     searchDocType: searchedForm.searchDocType || ''
  //   }
  //
  //   const response = await exportExcelReq(END_POINTS.DOWNLOAD_RSP_PROJ_INCOME_TRANS_LIST, {
  //     data,
  //     headerMap: await getCPHeaderMap(compId, projId),
  //     headerCodeMap: await getHeaderCodeMap(codeParam)
  //   })
  //   // console.log('exportExcelReq.resp:', response)
  //   return response
  // },
  END_ACTIONS() {}
}

const mutations = {
  // async updateSearchedForm(state) {
  //   state.searchedForm = {...state.searchInfo}
  // },
  // async updateSearchInfo(state, searchInfo) {
  //   state.searchInfo = {...searchInfo}
  // },
  // async resetSearchInfo(state) {
  //   state.searchInfo = {...state.emptySearchInfo}
  // },
  // updateSearchType(state, value) {
  //   state.searchInfo.searchType = value
  // },
  // updateSearchMonth(state, value) {
  //   state.searchInfo.searchMonth = value
  // },
  // updateSearchMonthType(state, value) {
  //   state.searchInfo.searchMonthType = value
  // },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  // updateSearchDocMth(state, value) {
  //   state.searchInfo.searchDocMth = value
  // },
  // updateSearchDocIndex(state, value) {
  //   state.searchInfo.searchDocIndex = value
  // },
  // updateSearchDocMonthIndex(state, value) {
  //   state.searchInfo.searchDocMonthIndex = value
  // },
  // updateSearchDocType(state, value) {
  //   state.searchInfo.searchDocType = value
  // },
  // updateSearchFirstId(state, value) {
  //   state.searchInfo.searchFirstId = value
  // },
  // updateSearchLastId(state, value) {
  //   state.searchInfo.searchLastId = value
  // },
  // updateSearchAction(state, value) {
  //   state.searchInfo.searchAction = value
  // },
  //
  updateRecordHistDataAuditList(state, list) {
    if (list.length) {
      state.recordHistDataAuditList = list
      // state.actionList = []
    } else {
      state.recordHistDataAuditList = []
    }
  },
  // updateActionListObject(state, response) {
  //   if (response.data.length) {
  //     state.actionListObject.actionList = response.data
  //   } else {
  //     state.actionListObject.actionList = []
  //   }
  //   state.actionListObject.firstId = response.firstId
  //   state.actionListObject.lastId = response.lastId
  //   state.actionListObject.searchAction = response.searchAction
  //   state.actionListObject.indPrev = response.indPrev
  //   state.actionListObject.indNext = response.indNext
  // },
  updateRecordHistDataAuditListEmpty(state) {
    // state.editIndex = -1
    // state.justUpdatedIndex = -1
    state.dataAuditList = []
    // state.actionListObject.firstId = ''
    // state.actionListObject.lastId = ''
    // state.actionListObject.searchAction = ''
    // state.actionListObject.indPrev = ''
    // state.actionListObject.indNext = ''
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/components/audit/recordHistDataAuditManage.js